import clsx from 'clsx';
import React from 'react';

import { closeCurrentMediaMobileMenu, openMediaMobileMenu } from 'Apollo/Store/Showroom/UserView/resolvers';
import { MediaInfoFragment, MediaType, Image, useGetMobileMenuOpenedQuery, ShowroomMobileMenuType } from 'generated/graphql';

import { getImageUrl, getVideoPreviewUrl } from 'lib/cloudinary';

import Grid from '@material-ui/core/Grid';

import ShowroomMediaActionsLayout from 'components/Showroom/MediaActionsLayout';

import { useStyles } from './styles';

export type ComponentProps = {
	id: string;
	media: MediaInfoFragment;
	menuType: ShowroomMobileMenuType;
	getDesktopActions(media: MediaInfoFragment): React.ReactNode;
	getMobileActions(media: MediaInfoFragment, closeMobileMenu: () => void): React.ReactNode;
};

const ShowroomBasketItem = (props: ComponentProps) => {
	const { id, media, menuType } = props;
	const { getDesktopActions, getMobileActions } = props;

	const classes = useStyles();

	const {
		data: {
			showroom: {
				userView: { activeMediaMobileMenu }
			}
		}
	} = useGetMobileMenuOpenedQuery();

	const isLandscape = React.useMemo(() => media.mediaType === MediaType.Video || (media as Image).width > (media as Image).height, [media]);
	const url = React.useMemo(() => {
		if (media.mediaType === MediaType.Video) return getVideoPreviewUrl(media.cloudinaryId, { version: media.cloudinaryVersion + '' });
		else return getImageUrl(media.cloudinaryId, { version: media.cloudinaryVersion + '' });
	}, [media]);

	const desktopActions = React.useMemo(() => getDesktopActions(media), [getDesktopActions, media]);
	const mobileActions = React.useMemo(() => getMobileActions(media, closeCurrentMediaMobileMenu), [getMobileActions, media]);

	const [actionsDisplayed, setActionsDisplayed] = React.useState(false);

	return (
		<Grid item key={media.id} md={isLandscape ? 3 : 2} sm={isLandscape ? 12 : 6} xs={12}>
			<ShowroomMediaActionsLayout
				id={id}
				actions={desktopActions}
				mobileActions={mobileActions}
				displayed={actionsDisplayed}
				mobileMenuOpen={activeMediaMobileMenu?.mediaId === media.id && activeMediaMobileMenu?.type === menuType}
				onDisplay={() => setActionsDisplayed(true)}
				onHide={() => setActionsDisplayed(false)}
				onOpenMobileMenu={() => openMediaMobileMenu(media.id, menuType)}
				onCloseMobileMenu={() => closeCurrentMediaMobileMenu()}
			>
				<div
					id={id}
					className={clsx(classes.basketItem, { [classes.basketItemLandscape]: isLandscape, [classes.basketItemPortrait]: !isLandscape })}
					style={{ backgroundImage: `url("${url}")` }}
				></div>
			</ShowroomMediaActionsLayout>
		</Grid>
	);
};

export default React.memo(ShowroomBasketItem);
